import { VueModule } from '@Foundation/utilities';
import ImagesMosaic from './code/Scripts/components/ImagesMosaic';
import imagesMosaicAdditionalTips from './code/Scripts/components/ImagesMosaicAdditionalTips';
export default VueModule({
  components: {
    ImagesMosaic,
    imagesMosaicAdditionalTips
  }
});
